'use client';
import 'leaflet/dist/leaflet.css';

import L from 'leaflet';
import React, { useEffect, useMemo } from 'react';
import { MapContainer, Marker, Popup, TileLayer, useMap } from 'react-leaflet';

import { DEFAULT_ZOOM, ZOOM_SNAP } from '@/constants';
import { PhotoGeo } from '@/types';

// Fix for default marker icons in React Leaflets
delete (L.Icon.Default.prototype as any)._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png',
  iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
});

export const Map = ({ geo, extraControls, children, bounds }: {
  geo?: PhotoGeo;
  extraControls?: React.ReactNode;
  children?: React.ReactNode;
  bounds?: [number, number][];
}) => {
  const center: [number, number] = useMemo(() => [geo?.lat || 0, geo?.lng || 0], [geo?.lat, geo?.lng]);
  const zoom = bounds ? undefined : DEFAULT_ZOOM;

  return (
    <div className="h-48 overflow-hidden rounded-lg map-container">
      <MapContainer
        center={center}
        bounds={bounds}
        zoom={zoom}
        style={{ height: '100%', width: '100%' }}
        zoomSnap={ZOOM_SNAP}
        zoomControl={false}
      >
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        />

        {children || (
          <Marker position={center}>
            <Popup>
              {geo?.name}, {geo?.region}, {geo?.province}, {geo?.state}
            </Popup>
          </Marker>
        )}

        {/* It seems we always need to "center" the map on load ¯\_(ツ)_/¯ */}
        <RecenterMap center={center} bounds={bounds} />
        {/* Is that maybe not true anymore? Maybe not, but we definitely need to do this when the point changes */}
        {extraControls}

      </MapContainer>
    </div>
  );
};

const RecenterMap = ({ center, bounds }: { center: [number, number]; bounds?: [number, number][] }) => {
  const map = useMap();

  useEffect(() => {
    if (map) {
      console.log('RecenterMap inner', map, center, bounds);
      if (bounds && bounds.length > 0) {
        map.fitBounds(bounds);
      } else if (center && center.length > 0) {
        map.setView(center, DEFAULT_ZOOM);
      }
    }
  }, [center, bounds, map]);

  return null;
};

export default Map;
